<template>
  <div class="custom-table-container">
    <input type="hidden" name="_token" :value="csrf" />
    <input v-if="this.editing" type="hidden" name="_method" value="PUT" />
   
    <table class="table table-custom-header">
      <thead>
        <tr>
          <th class="sticky-header sticky-col">{{ __("views.KPIAssociation.survey_question") }}</th>
          <th class="sticky-header" style="min-width:150px"
            v-for="(column, indexColumn) in columns"
            :key="indexColumn"
          >
            {{ column.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index_r) in rows" :key="index_r">
          <th class="sticky-col">
            {{ row.label }}
          </th>
          <td style="min-width:150px" v-for="(column, index_c) in columns" :key="index_c">
            <input
              v-if="row.edit > 1"
              :type="column.type"
              :checked="
                answers_list[index_r] == index_c && !empty_values
                  ? 'checked'
                  : ''
              "
              :class="'saveQuestion custom-radio ' + row.classRequired"
              :value="index_c"
              Evaluations="answers_list[index_r]"
              :name="'question[' + question_survey_id + '][' + index_r + ']'"
            />
            <div v-else>
              <label v-if="answers_list[index_r] == index_c && !empty_values">
                <i style="color: #2A9D8F" class="fa-solid fa-circle-check"></i></label
              >
              <label v-else></label>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  mounted() {
    this.answers_list = this.answers;
  },
  props: {
    evaluation_chart_id: {
      type: Number,
      required: true,
    },
    question_survey_id: {
      type: Number,
      required: true,
    },
    key_rows: {
      type: Array,
      required: true,
    },
    rows: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    answers: {
      type: Object,
      required: true,
    },
    empty_values: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      answers_list: [],
      action: "",
      editing: true,
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    };
  },
  methods: {},
};
</script>

<style scoped>

table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  width: 100%;
}

.table-custom-header thead tr th {
  background: transparent;
  color: #1767A2 !important;
  font-weight: 800 !important;
}

.custom-table-container {
  padding-right: 20px;
  width: 100%;
  overflow-x: auto;
  max-height: 80vh; 
  overflow-y: auto; 
}

.custom-radio,
.custom-checkbox {
  width: 22px;
  height: 22px;
}

.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  background-color: white !important;
  z-index: 2;
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.5); 
  min-width:200px !important;
}

.sticky-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: white !important;
  z-index: 1; 
}

</style>
